import React from 'react';
import NominationCard from '../components/nominationcard.js'
import { useMst } from '../models/root.js';
import { observer } from "mobx-react-lite";

const NominationsLeft=observer(()=>{
    const {unnominated} = useMst();

    function makeNominated(id){
        let nominated = unnominated.getNominatedUser(id);
        nominated.changeNominated(true);
    }

    return (
        <div class="h-2/3 fixed overflow-scroll">
            {unnominated.users.map((item)=>{
                if (item.nominated==false){ 
                return <div class="p-5 w-full">
                    <NominationCard id={item.id} name={item["name"]} email={item["email"]} pic_url={item["pic_url"]} makeNominated={makeNominated} dummy={false}/>
                </div>}}
            )}
        </div>
    );
})

export default NominationsLeft;